import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBatchSendTicket, getTicketRuleDetail, downloadBatchErrorTicket, BatchGiveTicket } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'TicketSend',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getBatchSendTicket,
      type: '',
      path: process.env.VUE_APP_BASE_API,
      fullscreenLoading: false,
      multipleSelection: [],
      addDialogVisible: false,
      ticketDialogVisible: false,
      reSendDialogVisible: false,
      dialogTitle: '',
      ticketRulesList: [],
      fileList: [],
      formData: {}
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formData = _this3.initData();

                _this3.getTableData();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        batchNo: '',
        batchName: '',
        userType: 3,
        userPhones: '',
        remark: '',
        batchTicket: '',
        giveticketRulesList: [this.initTicketSingle()]
      };
      return formdata;
    },
    initTicketSingle: function initTicketSingle() {
      return {
        ticketRuleNo: '',
        num: 1
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 添加券
    onAddTicket: function onAddTicket(index) {
      var that = this;
      that.formData.giveticketRulesList.splice(index + 1, 0, that.initTicketSingle());
    },
    // 删除券
    onDeleteTicket: function onDeleteTicket(index) {
      var that = this;

      if (that.formData.giveticketRulesList.length == 1) {
        return;
      }

      that.formData.giveticketRulesList.splice(index, 1);
    },
    onChangeUserType: function onChangeUserType() {
      if (this.formData.userType === 3) {
        this.formData.batchName = '补券-' + new Date().getTime();
        this.formData.remark = '补券';
      }

      if ([1, 2].includes(this.formData.userType)) {
        this.formData.batchName = '';
        this.formData.remark = '';
      }
    },
    // 获取券详情
    getTicketDetail: function getTicketDetail(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(item.ticketRuleNo.trim() != '')) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return getTicketRuleDetail({
                  'ticketRuleNo': parseFloat(item.ticketRuleNo)
                });

              case 3:
                res = _context4.sent;

                if (res.code == 0) {
                  item.ticketRuleNo = res.data.ticketRuleNo + '';
                } else {
                  item.ticketRuleNo = '';
                }

              case 5:
                _this4.$forceUpdate();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 查看
    onViewTicket: function onViewTicket(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var batchTicket, ticketRulesList, i, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                debugger;
                batchTicket = JSON.parse(row.batchTicket);
                ticketRulesList = [];
                i = 0;

              case 4:
                if (!(i < batchTicket.length)) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 7;
                return getTicketRuleDetail({
                  'ticketRuleNo': parseFloat(batchTicket[i].ticketRuleNo)
                });

              case 7:
                res = _context5.sent;
                res.data.num = batchTicket[i].num;
                ticketRulesList.push(res.data);

              case 10:
                i++;
                _context5.next = 4;
                break;

              case 13:
                _this5.ticketRulesList = ticketRulesList;
                _this5.ticketDialogVisible = true;
                _this5.dialogTitle = '查看优惠券';

                _this5.$forceUpdate();

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 重新发送
    onReSend: function onReSend(row) {
      this.formData.batchNo = row.batchNo;
      this.formData.batchName = row.batchName;
      this.formData.giveticketRulesList = JSON.parse(row.batchTicket);
      this.reSendDialogVisible = true;
      this.type = 'resend';
      this.dialogTitle = '重新发送失败的用户';
    },
    // 导出
    onExportError: function onExportError(row) {
      downloadBatchErrorTicket({
        'batchNo': row.batchNo
      }).then(function (res) {
        window.open(res.data.url);
      }, function (error) {});
    },
    // 新增
    onAdd: function onAdd() {
      this.type = 'add';
      this.addDialogVisible = true;
      this.dialogTitle = '新增批量送券';
      this.onChangeUserType();
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.ticketDialogVisible = false;
      this.reSendDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.stepActive = 1;
      this.ticketRulesList = [];
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.formData = this.initData();
      this.onSubmit();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;
      that.formData.userPhones = that.formData.userPhones.replace(/\s*/g, '');
      this.formData.batchTicket = JSON.stringify(this.formData.giveticketRulesList);

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'resend':
          that.handleResend();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 校验上传文件
    uploadBefore: function uploadBefore(file) {
      this.fullscreenLoading = true;
      var fileType = '';
      fileType = file.name.split('.');
      fileType = fileType[fileType.length - 1];
      var isExcel = ['xlsx', 'xls'].includes(fileType);

      if (!isExcel) {
        this.$message.error('只能上传excel格式文件!');
        this.fullscreenLoading = false;
        return false;
      }

      return true;
    },
    // 校验表单
    validFormData: function validFormData() {
      var that = this;
      this.fullscreenLoading = true;
      var valid = true;

      if (!that.formData.batchName || that.formData.batchName.trim() === '') {
        that.$message({
          type: 'warning',
          message: '请输入批次名称'
        });
        return false;
      }

      if ([1, 2].includes(that.formData.userType) && that.$refs.upload.uploadFiles.length === 0) {
        that.$message({
          type: 'warning',
          message: '请选择上传excel文件'
        });
        return false;
      }

      if ([3].includes(that.formData.userType) && that.formData.userPhones === '') {
        that.$message({
          type: 'warning',
          message: '请输入手机号'
        });
        return false;
      }

      if (that.formData.remark.trim() === '') {
        that.$message({
          type: 'warning',
          message: '请输入发券原因'
        });
        return false;
      }

      that.formData.giveticketRulesList.forEach(function (item) {
        if (!item.ticketRuleNo || !item.ticketRuleNo.trim() || item.num === '' || item.num < 1) {
          valid = false;
        }
      });

      if (!valid) {
        that.$message({
          type: 'warning',
          message: '请完善优惠券信息'
        });
        return false;
      }

      return true;
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this6 = this;

      var that = this;

      if (this.validFormData()) {
        this.$confirm('确定要发送吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
          var res;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if ([1, 2].includes(that.formData.userType)) {
                    that.$refs.upload.submit();
                  }

                  if (![3].includes(that.formData.userType)) {
                    _context6.next = 9;
                    break;
                  }

                  _context6.next = 4;
                  return BatchGiveTicket(that.formData);

                case 4:
                  res = _context6.sent;

                  if (!(res.code != 0)) {
                    _context6.next = 8;
                    break;
                  }

                  _this6.$message({
                    type: 'error',
                    message: res.msg
                  });

                  return _context6.abrupt("return");

                case 8:
                  _this6.closeDialog();

                case 9:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))).catch(function (err) {});
      }
    },
    // 重新发送保存
    handleResend: function handleResend() {
      var that = this;

      if (this.$refs.upload.uploadFiles.length === 0) {
        this.$message({
          type: 'warning',
          message: '请重新上传excel文件'
        });
        return false;
      }

      this.$confirm('确定要重新发送吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$refs.upload.submit();
      }).catch(function (err) {});
    },
    // 上传成功
    onUploadSuccess: function onUploadSuccess(res, file, fileList) {
      debugger;
      this.$refs.upload.clearFiles();

      if (res.code != 0) {
        this.$message({
          type: 'error',
          message: res.msg
        });
        return;
      }

      this.closeDialog();
    },
    // 上传失败
    onUploadError: function onUploadError(err, file, fileList) {
      debugger;
      this.$message({
        type: 'error',
        message: err
      });
    }
  }
};